import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

/**
 * Get CSRF token from spring boot on app initialization
 * @param httpClient
 */

export const getCsrfToken = function (httpClient: HttpClient): () => Observable<any> {
    return () => httpClient.get('/api/csrfToken');
}
